import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import * as z from "zod/v4";

export const getAdvancedFlowCount = {
  name: "getAdvancedFlowCount" as const,
  input: z.object({ schema: z.enum(SchemaType) }),
  output: z.object({ count: z.number() }),
};
